var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iframe-box"},[_c('div',{staticClass:"zhegai"}),(_vm.iframeSrc.length >= 0)?_c('iframe',{style:('height:' + _vm.resizeHeight),attrs:{"id":"iframe1","src":_vm.iframeSrc,"frameborder":"0"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }